module.exports = __webpack_public_path__ + "img/wallet-number-icon.2016e48e.svg";